<template>
  <section
    id="profile"
    class="4rah-profile-main"
    :dir="$functions.currentLangDirection()"
    style="width: 100vw;
            padding: 0px !important;
            margin: 0px !important;
            top: 62px !important;
            left: 0px !important;"
  >
    <b-card style="height: calc(100vh);top: -60px;">
      <b-card-body>
        <v-tabs
          light
          right
        >
          <v-tab>{{ $t('Settings') }}</v-tab>
          <v-tab
            v-if="usertype == 2"
          >{{ $t('Management') }}</v-tab>

          <v-tab-item
            :key="1"
          >
            <v-list light>
              <v-list-item-group
                v-model="selectedItem"
                color="primary"
              >
                <v-list-item
                  v-for="(item, i) in itemsUser"
                  :key="i"
                  @click="tabClick(item.rout)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t(item.text)" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

          </v-tab-item>
          <v-tab-item
            v-if="usertype == 2"
            :key="2"
          >
            <v-list light>
              <v-list-item-group
                v-model="selectedItem2"
                color="primary"
              >
                <v-list-item
                  v-for="(item, i) in itemsManager"
                  :key="i"
                  @click="tabClick(item.rout)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="item.icon" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t(item.text)" />
                  </v-list-item-content>
                </v-list-item>

              </v-list-item-group>
            </v-list>

          </v-tab-item>
        </v-tabs>
        <div class="row" style="">
          <div class="col-12">
            <div style="display: flex;">
                <span style="padding: 5px;">{{ $t('Select language') }} :
                  </span>
              <div style="width: 62px;" >
                <SwitchLang
                    :init-lang="initLang"
                    :options="optionsLang"
                    :label="optionsLang.flag"
                    @changed="changeAppLanguage"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- نمایش ورژن اپلیکیشن -->
        <div class="app-version-box">
          <div class="version-info">
            <v-icon small color="grey">mdi-information-outline</v-icon>
            <span class="version-label">{{ $t('App Version') }}:</span>
            <span class="version-number">{{ appVersion }}</span>
          </div>
          <div class="version-build">
            Build {{ appBuild }}
          </div>
        </div>
      </b-card-body>
    </b-card>

  </section>

</template>
<script>
import Vue from 'vue'
import {BButton, BCard, BCardBody, BTab,} from 'bootstrap-vue'
import router from '@/router'
import {getUserData} from '@/auth/utils'
import { APP_VERSION, APP_BUILD } from '@/version'
// eslint-disable-next-line import/no-extraneous-dependencies
import SwitchLang from 'vue-switch-lang'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'vue-switch-lang/dist/vue-switch-lang.css'

export default {
  components: {
    SwitchLang,
    BTab,
    BCard,
    BCardBody,
    BButton,
  },
  data: () => ({
    appVersion: APP_VERSION,
    appBuild: APP_BUILD,
    initLang: {
      title: 'fa',
      flag: 'ir',
    },
    optionsLang: [{ title: 'en', flag: 'gb' }, { title: 'fa', flag: 'ir' }, { title: 'ar', flag: 'sa' }],

    usertype: getUserData().type,
    tab: null,
    selectedItem: -1,
    selectedItem2: -1,
    itemsUser: [
      { text: 'تمدید اشتراک', icon: 'mdi-credit-card-refresh', rout: 'subscription-renew' },
      { text: 'تراکنش‌های من', icon: 'mdi-history', rout: 'payment-transactions' },
      { text: 'تنظیم رمز عبور', icon: 'mdi-lock-reset', rout: 'set-password' },
      { text: 'catalog', icon: 'mdi-book-open', rout: 'catalog' },
      { text: 'FAQ', icon: 'mdi-apps', rout: 'faq' },
      { text: 'گفتگوی آنلاین', icon: 'mdi-chat', rout: 'onlineChat' },
      { text: 'Sign Out', icon: 'mdi-logout', rout: 'logout' },
    ],
    itemsManager: [
      { text: 'Clients', icon: 'mdi-account', rout: 'admin-customer-list' },
      { text: 'Resellers', icon: 'mdi-message-bulleted', rout: 'admin-agent-list' },
      { text: 'Devices', icon: 'mdi-shopping', rout: 'admin-device-all' },
      { text: 'Models', icon: 'mdi-apps', rout: 'admin-model-list' },
      { text: 'Managers', icon: 'mdi-apps', rout: 'admin-manager-list' },
      { text: 'Servers', icon: 'mdi-apps', rout: 'admin-server-list' },
    ],
  }),
  computed: {
  },
  beforeMount() {
    this.optionsLang.forEach(item => {
      if (item.title === localStorage.getItem('locale')) {
        this.initLang = {
          title: item.title,
          flag: item.flag,
        }
      }
    })
  },
  mounted() {

  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
    },
  },
  methods: {
    changeAppLanguage(lang) {
      localStorage.setItem('locale', lang.title)
      window.location = '/'
    },
    tabClick(rout) {
      if (rout === 'logout') {
        // eslint-disable-next-line no-restricted-globals,no-alert
        if (confirm(this.$t('Are you sure'))) {
          this.$store.dispatch('auth/logout')
          this.$router.push('/login')
        }
      } else if (rout === 'onlineChat') {
        this.$router.push({ name: 'onlineChat' })
      } else if (rout === 'catalog') {
        const subscribeUrl = 'https://web.4-rah.com/catalog.pdf'
        if (Vue.prototype.$productionPlatform === 'ios') {
          window.location.href = `http://127.0.0.1:3232/QXNative/?action=launchBrowser-openUrl&url=${encodeURIComponent(subscribeUrl)}`
        } else {
          window.location.href = subscribeUrl
        }
      } else if (rout === 'renewSubscription' || rout === 'inbox' || rout === 'shop' ) {
        const subscribeUrl = 'https://4-rah.com/%D8%AA%D9%85%D8%AF%DB%8C%D8%AF-%D8%AD%D8%B3%D8%A7%D8%A8-%DA%A9%D8%A7%D8%B1%D8%A8%D8%B1%DB%8C/'
        switch (rout) {
          case 'renewSubscription':
            if (Vue.prototype.$productionPlatform === 'ios') {
              window.location.href = `http://127.0.0.1:3232/QXNative/?action=launchBrowser-openUrl&url=${encodeURIComponent(subscribeUrl)}`
            } else {
              window.location.href = subscribeUrl
            }
            break
          default:
            if (Vue.prototype.$productionPlatform === 'ios') {
              window.location.href = 'http://127.0.0.1:3232/QXNative/?action=launchBrowser-openHomePage'
            } else {
              window.location.href = 'https://4-rah.com'
            }
        }
      } else if (rout === 'set-password' && Vue.prototype.$functions.isMobile()) {
        this.$emit('on-change-page', 'setPassword')
      } else {
        // eslint-disable-next-line no-unused-vars
        router.push({ name: rout }).catch(err => {})
      }
    },
    addClick() {
      router.push({ name: 'admin-device-add' })
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'model-list' })
    },
  },
}
</script>

<style>
#profile {
  /*background-color: #232633;*/
  z-index: 9;
}
#profile .card, #profile .card-body {
  /*background-color: #232633;*/
  border-radius: 0;
}
#profile .theme--dark.v-list{
  /*background-color: #232633 !important;*/
}
[dir] #profile .theme--dark.v-tabs > .v-tabs-bar{
  /* background-color: #232633 !important;
   color: #fff;*/
}
.v-tab{
  letter-spacing: normal !important;
}
#profile .v-list-item{
  padding: 5px;
  box-shadow: 0 1px 0px rgb(253, 253, 253), 0 1px 0px rgba(0, 0, 0, 0);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 7px;

}
#profile .v-list-item__icon{
  margin: 16px 10px;
}

.multiselect__option--selected {
  background-color: red;
}

.multiselect__option--highlight {
  background-color: #c6c6c7;
  background: #c6c6c7;
}
[dir] .multiselect__single{
  background: #fff0 !important;
  padding-right: 0px !important;
  margin-right: -10px !important;
}
[dir] .multiselect__tags{
  height: 32px!important;
  background: #fff0 !important;
}
[dir] .multiselect__select{
  width: 26px;
  border: 0;
  background: #fff0 !important;

  top: -2px;
}
[dir] .multiselect__option{
  padding: 1px;
}
[dir=ltr] .multiselect__single{
  left: 10px;
  display: block;
}
[dir] .normal-flag{
  transform: scale(.45) !important;
  -webkit-transform: scale(.45) !important;
}
.normal-flag[data-v-31fb7232]{
  margin-top: -5px;
  margin-right: -10px;
}

/* استایل باکس ورژن */
.app-version-box {
  position: fixed;
  bottom: 70px;
  left: 0;
  right: 0;
  text-align: center;
  padding: 10px;
  background: linear-gradient(to top, rgba(255,255,255,0.95), rgba(255,255,255,0.8));
  border-top: 1px solid #eee;
}
.app-version-box .version-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 14px;
  color: #666;
}
.app-version-box .version-label {
  color: #888;
}
.app-version-box .version-number {
  font-weight: bold;
  color: #333;
  background: #e3f2fd;
  padding: 2px 8px;
  border-radius: 4px;
}
.app-version-box .version-build {
  font-size: 11px;
  color: #999;
  margin-top: 2px;
}
</style>
